import { generateAuthUrl } from "@/utils/rubiconCrypto";

/**
 * 
 * @param {vueThis 컨텍스트} vueThis 
 */
export const moveToRubicon = async (vueThis) => {
    try {
        vueThis.$showLoading();
        const appPhase = process.env.VUE_APP_PHASE;
        const channel = process.env.VUE_APP_RUBICON_CHANNEL;
        const token = localStorage.getItem("token");
        const data = { additional: 'data' };
        const countryName = localStorage.getItem("responsibilityName");

        console.log("CountryName : ", countryName);

        const rubiconResult = await generateAuthUrl(appPhase, countryName, { token, channel, data });
        console.log("RUBICON RESULT : ", rubiconResult);
        const rubiconLink = new URL(rubiconResult)
        rubiconLink.searchParams.set("linkType", "INTERNAL_LINK");
        console.log("RUBICON LINK : ", rubiconLink);
        console.log("RUBICON LINK STRING : ", rubiconLink.toString());
        window.open(rubiconLink.toString(), "_blank");
    } catch (error) {
        console.warn("RUBICON LINK ERROR : ", error);
    } finally {
        vueThis.$hideLoading();
    }
}